<template
  ><div>
    <component :is="componentName" v-model="translation" :required="languageId === 1">
    </component>
  </div>
</template>

<script>
import { cloneDeep, isEmpty } from 'lodash';

export default {
  name: 'AppContentForm',

  model: {
    prop: 'appContent'
  },

  props: {
    formPath: {
      type: String,
      required: true
    },
    appContent: {
      type: Object,
      required: true
    },
    languageId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    valid: true,
    localAppContent: null,
    translation: {}
  }),

  computed: {
    componentName() {
      return () => import(`@/${this.formPath}`);
    }
  },

  watch: {
    appContent: {
      deep: true,
      handler() {
        if (
          JSON.stringify(this.appContent) ===
          JSON.stringify(this.localAppContent)
        ) {
          return;
        }
        this.setData();
      }
    },
    translation: {
      deep: true,
      handler: 'setTranslation'
    }
  },

  created() {
    this.setData();
  },

  methods: {
    setData() {
      this.localAppContent = cloneDeep(this.appContent);
      this.translation = this.getTranslation(this.localAppContent.translations);
    },
    getTranslation(item) {
      if (isEmpty(item)) {
        return {};
      }
      return item.find(el => el.language_id === this.languageId) || {};
    },
    setTranslation(item) {
      if (isEmpty(item)) {
        return;
      }

      let index = -1;
      if (this.localAppContent.translations) {
        index = this.localAppContent.translations.findIndex(
          i => i.language_id === this.languageId
        );
      } else {
        this.localAppContent.translations = [];
      }

      if (index === -1) {
        index = this.localAppContent.translations.length;
        item['language_id'] = this.languageId;
      }

      this.localAppContent.translations[index] = item;
      this.$emit('input', Object.assign({}, this.localAppContent));
    }
  }
};
</script>
